import { render, staticRenderFns } from "./cotacoes-table.vue?vue&type=template&id=d7b01bb0&"
import script from "./cotacoes-table.vue?vue&type=script&lang=js&"
export * from "./cotacoes-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports